/* @flow weak */
import PropTypes from 'prop-types';
import * as React from 'react';
import enumerate from 'lib/enumerate';
import Button from 'components/Button';
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';
import LoadingIndicator from 'components/LoadingIndicator';
import AuthenticationView from 'auth/components/AuthenticationView';
import './styles/SessionSyncPage.scss';

const STATUS = enumerate(['loading', 'finished']);

class SessionSyncPage extends React.Component<{}, $FlowFixMeState> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    user: null,
    status: STATUS.loading,
  };

  componentDidMount() {
    AuthActions.checkLoggedInAndLoadAppData()
      .then(user => {
        this.setState({
          status: STATUS.finished,
          user,
        });
      })
      .catch(() => {
        ToastActions.showErrorToast('Oops, you need to log in again.');
        this.context.router.push('/log_in');
      });
  }

  confirmNewSession = () => {
    window.location = '/classes';
  };

  resetSession = () => {
    AuthActions.signOut('/log_in');
  };

  renderFinished = () => {
    return (
      <div>
        {this.renderHeader()}

        <Button
          full
          className="SessionSyncPage-Button"
          onClick={this.confirmNewSession}
          eventElementName="SessionSyncPage-Button">
          Log in with {this.state.user.getEmail()}
        </Button>

        <Button
          full
          className="SessionSyncPage-Button"
          onClick={this.resetSession}
          eventElementName="SessionSyncPage-Button">
          Log in with another email address
        </Button>
      </div>
    );
  };

  renderHeader = () => {
    return (
      <div>
        <h3 className="SessionSyncPage-Title">It looks like you’re already logged in to Remind</h3>

        <p>Which account do you want to use?</p>
      </div>
    );
  };
  renderLoading = () => {
    return (
      <div>
        {this.renderHeader()}
        <LoadingIndicator size="medium" />
      </div>
    );
  };
  render() {
    const body = {
      [STATUS.loading]: this.renderLoading,
      [STATUS.finished]: this.renderFinished,
    }[this.state.status]();
    return (
      <AuthenticationView>
        <div className="SessionSyncPage">{body}</div>
      </AuthenticationView>
    );
  }
}
export default SessionSyncPage;
